import './DropdownMenu.css'

interface DropdownMenuProps {
    title: string
    children: React.ReactNode
    isOpen?: boolean
    setIsOpen?: (isOpen: boolean) => void
    minWidth?: number
}

export const DropdownMenu: React.FC<DropdownMenuProps> = ({ title, children, isOpen, setIsOpen, minWidth }) => {

    return (
        <div className="dropdown-container">
            <div className="dropdown-trigger"
                onClick={() => setIsOpen?.(!isOpen)}
                style={{ minWidth: `${minWidth || 200}px` }}
            >
                <span className="dropdown-title">{title}</span>
                <svg
                    className={`dropdown-arrow ${isOpen ? 'open' : ''}`}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <path
                        d="M7 14L12 9L17 14"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </div>
            {isOpen && (
                <div className="dropdown-content">
                    {children}
                </div>
            )}
        </div>
    )
} 